import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from 'react-spinkit';
import isEmpty from 'lodash/isEmpty';
import { Link, useHistory } from 'react-router-dom';
import AnalyticsDataTable from '../../components/AnalyticsDataTable';
import { fetchStatisticRequested } from '../../store/analytics/actions';

function AnalyticsPage() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { isEventsLoading, events } = useSelector(state => state.analytics);

  useEffect(() => {
    // dispatch(AnalyticsActions.fetchEvents());
    dispatch(fetchStatisticRequested());
  }, []);

  const userLinkElement = (user) => {
    if (isEmpty(user)) return '';
    return (<Link
        className="nav-link"
        to={{
          pathname: '/dashboard/users/' + user.id + '/edit',
        }}
        key={user.id}
      >
        {user.display_name} ({user.phone_number})
      </Link>
    );
  };

  const columns = useMemo(() => ([
    {
      field: 'id',
      title: 'id',
    },
    {
      field: 'event_name',
      title: 'Событие'
    },
    {
      field: 'emitter_user',
      title: 'Автор',
      render: rowData => (userLinkElement(rowData.emitter_user))
    },
    {
      field: 'linked_user',
      title: 'Связанный',
      render: rowData => (userLinkElement(rowData.linked_user))
    },
    {
      field: 'inserted_at',
      title: 'Дата'
    },
    {
      field: 'internal_description',
      title: 'Внутренний комментарий',
      render: rowData => <p style={{
        width: '150',
      }}>{rowData.internal_description}</p>
    },
  ]), []);

  const onEdit = (rowData) => {
    history.push(`/dashboard/analytics/${rowData.id}/edit`, { event: rowData });
  };

  return (
    <div
      style={{ width: '100%' }}
    >
      {
        isEventsLoading &&
        <div>
          <Spinner name="circle" className="spinner" fadeIn="quarter" color="#3897dc"/>
          <div className="overlay">
          </div>
        </div>
      }
      <div>
        <h3>Аналитика</h3>
      </div>
      <br/>
      <AnalyticsDataTable
        title={null}
        data={events}
        columns={columns}
        onEdit={onEdit}
      />
    </div>
  );
}

export default AnalyticsPage;



// WEBPACK FOOTER //
// ./src/pages/AnalyticsPage/index.jsx